export default __webpack_public_path__ + "static/N11V9A8I-61a57e4a614392292712712aea7e73df.jpg";